<template>
  <div class="form-modal" @keydown.esc="secondaryBtnAction" ref="formModal">
    <div class="form-modal__container">
      <component
        mode="modal"
        :is="loadComponentPath"
        @onPrimaryButtonClick="primaryBtnAction"
        @onSecondaryButtonClick="secondaryBtnAction"
      />
    </div>
  </div>
</template>
<script setup>
import { onMounted, computed, ref, defineAsyncComponent } from "vue";
import gsap from "gsap";

const props = defineProps({
  modalOptions: {
    type: Object,
    required: true,
  },
});
const emit = defineEmits(["onPrimaryButtonClick", "onSecondaryButtonClick"]);
const formModal = ref(null);

const loadComponentPath = computed(() =>
  defineAsyncComponent({
    loader: async () => {
      const comps = import.meta.glob("../../forms/**/*.vue");
      const match =
        comps[`../../forms/${props.modalOptions.componentPath}.vue`];
      const page = (await match()).default;
      return page;
    },
  })
);

const primaryBtnAction = () => {
  if (props.modalOptions.primaryBtnAction) {
    props.modalOptions.primaryBtnAction();
  }

  return emit("onPrimaryButtonClick");
};

const secondaryBtnAction = () => {
  if (props.modalOptions.secondaryBtnAction) {
    props.modalOptions.secondaryBtnAction();
  }

  return emit("onSecondaryButtonClick");
};

onMounted(() => {
  formModal.value.focus();

  const successTl = gsap.timeline();
  successTl.fromTo(
    ".form-modal",
    {
      duration: 0.75,
      y: 30,
      opacity: 0,
    },
    {
      y: 0,
      opacity: 1,
      delay: 0.5,
      ease: "inOut.power3",
    }
  );
});
</script>
<style lang="scss" scoped>
.form-modal {
  opacity: 0;
  background: var(--modal-content-background);
  border-radius: $border-radius $border-radius 0 0;

  @include breakpoint($min-m) {
    border-radius: $border-radius;
  }

  &__container {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;

    @include breakpoint($min-m) {
      padding: 3rem;
      // max-width: 468px;
    }
  }
}
</style>
